import { FC, useEffect } from 'react';
import CashbackHeader from './containers/CashbackHeader/CashbackHeader';
import CashbackTable from './containers/CashbackTable/CashbackTable';
import { cashbackStore } from './store/cashbackStore';
import { marketingNavigation } from 'src/view/screens/MarketingScreen/constants/marketing';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';

const Cashback: FC = (): JSX.Element => {
  useEffect(() => {
    cashbackStore.getActiveCashbacksCount();
  }, []);

  return (
    <>
      <ScreenHeader title="marketing_role" options={marketingNavigation()} />
      <div className="d-flex flex-column flex-grow-1">
        <CashbackHeader />
        <div className="d-flex flex-row flex-grow-1">
          <CashbackTable />
        </div>
      </div>
    </>
  );
};

export default Cashback;
